import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Icon } from "@root/shared/components/Icon";
import { TextArea } from "@root/shared/components/TextArea";
import { Button } from "@root/shared/components/Button";
import { TextButton } from "@root/shared/components/TextButton";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  comment: string;
  onCommentChange: (value: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
};

export const CommentModal: FC<Props> = ({
  isOpen,
  onClose,
  comment,
  onCommentChange,
  onSubmit,
  isSubmitting,
}) => {
  const isCommentNotSubmittable = isSubmitting || !comment.trim();

  return (
    <Modal isShow={isOpen} pcWidthType="small" headerTitleStyle="white" onClose={onClose}>
      <>
        <div className={styles.modalHeader}>
          <p className={styles.modalTitle}>
            <Icon name="done" color={colors.Orange} />
            投票ありがとうございます！
          </p>
          <p className={styles.modalSubtitle}>
            エントリー作品に
            <br />
            コメントを送ってみませんか？
          </p>
        </div>
        <div className={styles.modalTextAreaSection}>
          <TextArea
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder="コメントを入力してください"
            size="large"
            className={styles.textArea}
          />
        </div>
        <div>
          <Button
            theme={isCommentNotSubmittable ? "disabled" : "primary"}
            size="large"
            className={styles.modalSubmitButton}
            onClick={onSubmit}
          >
            {isSubmitting ? "送信中..." : "送信する"}
          </Button>
          <div className={styles.modalCancelButtonContainer}>
            <TextButton isBold size="large" onClick={onClose}>
              コメントを送らない
            </TextButton>
          </div>
        </div>
      </>
    </Modal>
  );
};
